import { Logger } from '../../../logger/Logger';
import { Telemetry } from '../../../telemetry/Telemetry';
import type { FeatureServiceFetcher } from '../fetchers/types';
import type { FeatureConfigList } from '../types';

export class FeatureLoggingMiddleware implements FeatureServiceFetcher {
  constructor(
    private jsonFetcher: FeatureServiceFetcher,
    private pmsFetcher: FeatureServiceFetcher,
    private options: {
      use: FeatureServiceFetcher;
    }
  ) {}

  async fetch(): Promise<FeatureConfigList> {
    const jsonPromise = this.jsonFetcher.fetch();

    const pmsPromise = this.pmsFetcher.fetch().then((featureConfigList) => {
      Object.entries(featureConfigList).forEach(([key, value]) => {
        Telemetry.report({
          type: 'pmsFeature',
          name: key,
          payload: [`${value}`],
        });
      });
      return featureConfigList;
    });

    Promise.all([jsonPromise, pmsPromise]).then(([jsonList, pmsList]) => {
      Object.keys(jsonList).forEach((key) => {
        const missing = pmsList[key] === undefined;
        const valueMismatch = jsonList[key] !== pmsList[key];
        if (missing || valueMismatch) {
          Logger.logFailure('featureMismatch', {
            place: key,
            additional: missing ? 'missing' : 'value',
          });
        }
      });
    });

    return this.options.use === this.pmsFetcher ? pmsPromise : jsonPromise;
  }
}
